import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function ReportsPage() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/reports/overview").then(({ data }) => setR(data)); }, []);
  if (!r) return <div className="opacity-65">Loading...</div>;

  const attendanceLabels = ["confirmed", "present", "no_show", "completed"];

  return (
    <div data-testid="admin-reports-page">
      <h1 className="font-heading text-3xl">Reports</h1>
      <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Total Bookings" value={r.total_bookings} />
        <Stat label="Paid Bookings" value={r.paid_bookings} />
        <Stat label="Deposits (INR)" value={`₹${r.total_deposits.toLocaleString("en-IN")}`} />
        <Stat label="Attendance Rate" value={r.total_bookings ? `${Math.round(((r.attendance.present || 0) + (r.attendance.completed || 0)) / r.total_bookings * 100)}%` : "—"} />
      </div>

      <div className="mt-8 grid lg:grid-cols-2 gap-6">
        <section className="bg-white border border-[color:var(--border)] rounded-md p-5">
          <h2 className="font-heading text-2xl">Most Booked Poojas</h2>
          <ul className="mt-3 divide-y divide-[color:var(--border)]">
            {r.most_booked.map((m) => (
              <li key={m.pooja_slug} className="py-2 flex justify-between text-sm">
                <span>{m.pooja_name}</span>
                <span className="font-medium text-[color:var(--brand)]">{m.count}</span>
              </li>
            ))}
            {r.most_booked.length === 0 && <li className="text-sm opacity-65 py-2">No data yet.</li>}
          </ul>
        </section>

        <section className="bg-white border border-[color:var(--border)] rounded-md p-5">
          <h2 className="font-heading text-2xl">Attendance Breakdown</h2>
          <ul className="mt-3 divide-y divide-[color:var(--border)]">
            {attendanceLabels.map((k) => (
              <li key={k} className="py-2 flex justify-between text-sm">
                <span className="capitalize">{k.replace("_", " ")}</span>
                <span className="font-medium">{r.attendance[k] || 0}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="bg-white border border-[color:var(--border)] rounded-md p-5 lg:col-span-2">
          <h2 className="font-heading text-2xl">Monthly Trends</h2>
          <div className="mt-3 flex items-end gap-3 min-h-[140px]">
            {r.monthly_trends.length === 0 && <div className="text-sm opacity-65">No data yet.</div>}
            {r.monthly_trends.map((m) => {
              const max = Math.max(...r.monthly_trends.map((x) => x.count), 1);
              const h = (m.count / max) * 100;
              return (
                <div key={m.month} className="flex-1 flex flex-col items-center gap-2">
                  <div className="w-full rounded-t bg-[color:var(--brand)]/80" style={{ height: `${h}%` }} />
                  <div className="text-[10px] opacity-65">{m.month}</div>
                  <div className="text-xs font-medium">{m.count}</div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="bg-white rounded-md border border-[color:var(--border)] p-5">
      <div className="text-xs uppercase tracking-[0.18em] opacity-60">{label}</div>
      <div className="font-heading text-3xl mt-2 text-[color:var(--brand)]">{value}</div>
    </div>
  );
}
